import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import DocumentIcon from "../../../components/Icons/DocumentIcon";
import BankIcon from "../../../components/Icons/BankIcon";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import ViewDocumentModal from "../../Sites/ViewDocumentModal";
import moment from "moment";
import { formatAmount } from "../../../utility/CommonFunctions";
import BgBlurLoader from "../../../components/Loaders/BgBlurLoader";
import MainHeading from "../../../components/comman/MainHeading";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";

export default function PaymentAdvisoryDetail() {
  let { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [paymentAdvisoryData, setPaymentAdvisoryData] = useState({});
  const [modal, setModal] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);

  const toggleModal = () => {
    setModal(!modal);
  };

  useEffect(() => {
    GetPaymentAdvisoryDetail();
  }, []);

  const GetPaymentAdvisoryDetail = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl?.get_voucher_details + `?voucherId=${id}`;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        setPaymentAdvisoryData(response?.data);
      } else {
        toast.error(response?.message);
      }
    });
  };

  const handleDocumentClick = (item) => {
    const docUrl = {
      url: item?.url,
    };
    setSelectedDocument(docUrl);
    setModal(true);
  };

  const transaction = paymentAdvisoryData?.Transactions?.[0];
  const isCash =
    transaction?.paymentMethod === "Cash" ||
    paymentAdvisoryData?.paymentMethod === "Cash";
  const isBankTransfer =
    transaction?.paymentMethod === "NEFT" ||
    transaction?.paymentMethod === "RTGS" ||
    transaction?.paymentMethod === "IMPS";

  const ptTicket = paymentAdvisoryData?.paymentticket;
  const stTicket = paymentAdvisoryData?.salaryticket;
  const hasTicket = Boolean(ptTicket?.ticketNumber || stTicket?.ticketNumber);
  const siteName = ptTicket?.site?.name || stTicket?.site?.name || "--";

  return (
    <>
      {isLoading && <BgBlurLoader />}
      <div className="content container-fluid pb-5">
        {/* Main Header */}
        <MainHeading
          title="Payment Advisory Detail"
          showBackButton={true}
        />

        {/* Master Summary Card */}
        <div
          className="card border-0 shadow-sm rounded-3 mb-4"
          style={{ background: "#ffffff" }}
        >
          <div className="card-body p-4">
            {/* Top Identity Strip */}
            <div
              className="d-flex align-items-start justify-content-between flex-wrap gap-3 pb-3 border-bottom"
              style={{ borderColor: "#f1f5f9" }}
            >
              <div className="d-flex align-items-center gap-3">
                <div
                  className="d-inline-flex align-items-center justify-content-center rounded-3 p-2.5 flex-shrink-0"
                  style={{
                    background: "#eff6ff",
                    color: "#2563eb",
                    width: "48px",
                    height: "48px",
                    fontSize: "22px",
                  }}
                >
                  💳
                </div>
                <div>
                  <div className="d-flex align-items-center gap-2 flex-wrap">
                    <h3
                      className="mb-0 fw-bold text-dark"
                      style={{ letterSpacing: "-0.02em", fontSize: "1.35rem" }}
                    >
                      {paymentAdvisoryData?.voucherNumber || "--"}
                    </h3>

                    {/* Linked Ticket Badge */}
                    {ptTicket?.ticketNumber && (
                      <span
                        className="badge rounded-pill px-2.5 py-1 fw-semibold d-inline-flex align-items-center gap-1 cursor-pointer"
                        style={{
                          fontSize: "12px",
                          background: "#eff6ff",
                          color: "#1d4ed8",
                          border: "1px solid #bfdbfe",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          navigate(
                            `${RoutesLink.payment_tickets_details}/${ptTicket?.id}`
                          )
                        }
                        title="Click to view Payment Ticket"
                      >
                        <span>🎫</span>
                        <span>PT: {ptTicket?.ticketNumber} ↗</span>
                      </span>
                    )}

                    {stTicket?.ticketNumber && (
                      <span
                        className="badge rounded-pill px-2.5 py-1 fw-semibold d-inline-flex align-items-center gap-1 cursor-pointer"
                        style={{
                          fontSize: "12px",
                          background: "#fdf2f8",
                          color: "#be185d",
                          border: "1px solid #fbcfe8",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          navigate(
                            `${RoutesLink.salary_ticket_detail}/${stTicket?.id}`
                          )
                        }
                        title="Click to view Salary Ticket"
                      >
                        <span>💼</span>
                        <span>ST: {stTicket?.ticketNumber} ↗</span>
                      </span>
                    )}

                    {/* Ticket Type Badge */}
                    {ptTicket?.type && (
                      <span
                        className="badge rounded-pill px-2.5 py-1 fw-semibold d-inline-flex align-items-center gap-1"
                        style={{
                          fontSize: "12px",
                          background:
                            ptTicket?.type === "AgainstPO"
                              ? "#eff6ff"
                              : ptTicket?.type === "General"
                              ? "#f1f5f9"
                              : "#fef3c7",
                          color:
                            ptTicket?.type === "AgainstPO"
                              ? "#1d4ed8"
                              : ptTicket?.type === "General"
                              ? "#334155"
                              : "#92400e",
                          border: `1px solid ${
                            ptTicket?.type === "AgainstPO"
                              ? "#bfdbfe"
                              : ptTicket?.type === "General"
                              ? "#cbd5e1"
                              : "#fde68a"
                          }`,
                        }}
                      >
                        <span>
                          {ptTicket?.type === "AgainstPO"
                            ? "Against PO"
                            : ptTicket?.type === "General"
                            ? "General"
                            : "Miscellaneous"}
                        </span>
                      </span>
                    )}

                    {/* Payment Method Badge */}
                    {transaction?.paymentMethod && (
                      <span
                        className="badge rounded-pill px-2.5 py-1 fw-semibold"
                        style={{
                          fontSize: "12px",
                          background: "#ecfdf5",
                          color: "#059669",
                          border: "1px solid #a7f3d0",
                        }}
                      >
                        {transaction?.paymentMethod}
                      </span>
                    )}
                  </div>

                  <div className="text-secondary small mt-1 d-flex align-items-center gap-2 flex-wrap">
                    <span className="d-inline-flex align-items-center gap-1">
                      <span>📍</span>
                      <span>
                        <strong>Site:</strong> {siteName}
                      </span>
                    </span>
                    <span>•</span>
                    <span className="d-inline-flex align-items-center gap-1">
                      <span>📅</span>
                      <span>
                        <strong>Transaction Date:</strong>{" "}
                        {paymentAdvisoryData?.transactionDate
                          ? moment(
                              paymentAdvisoryData.transactionDate
                            ).format("DD MMM YYYY")
                          : "--"}
                      </span>
                    </span>
                    {transaction?.user?.name && (
                      <>
                        <span>•</span>
                        <span className="d-inline-flex align-items-center gap-1">
                          <span>👤</span>
                          <span>
                            <strong>Disbursed By:</strong>{" "}
                            {transaction.user.name}
                          </span>
                        </span>
                      </>
                    )}
                  </div>
                </div>
              </div>

              {/* Quick Quantitative Stats */}
              <div className="d-flex align-items-center gap-2 flex-wrap">
                <div
                  className="px-3.5 py-2 rounded-2 text-center"
                  style={{
                    background: "#f0fdf4",
                    border: "1px solid #bbf7d0",
                    minWidth: "140px",
                  }}
                >
                  <div
                    className="text-uppercase"
                    style={{
                      fontSize: "10.5px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                      color: "#166534",
                    }}
                  >
                    Disbursed Amount
                  </div>
                  <div
                    className="fw-bold text-success"
                    style={{
                      fontSize: "18px",
                      lineHeight: "1.2",
                      marginTop: "2px",
                    }}
                  >
                    {formatAmount(transaction?.amount) || "--"}
                  </div>
                </div>

                <div
                  className="px-3.5 py-2 rounded-2 text-center"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    minWidth: "120px",
                  }}
                >
                  <div
                    className="text-secondary text-uppercase"
                    style={{
                      fontSize: "10.5px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Payment Mode
                  </div>
                  <div
                    className="fw-bold text-dark"
                    style={{
                      fontSize: "16px",
                      lineHeight: "1.2",
                      marginTop: "2px",
                    }}
                  >
                    {transaction?.paymentMethod || "--"}
                  </div>
                </div>
              </div>
            </div>

            {/* Key Information Grid */}
            <div className="row g-3 pt-3">
              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    {ptTicket?.ticketNumber ? "Payment Ticket No." : "Salary Ticket No."}
                  </div>
                  {ptTicket?.ticketNumber ? (
                    <div
                      className="fw-semibold text-primary text-truncate cursor-pointer"
                      title="Click to view Payment Ticket"
                      style={{ fontSize: "13.5px", cursor: "pointer" }}
                      onClick={() =>
                        navigate(
                          `${RoutesLink.payment_tickets_details}/${ptTicket.id}`
                        )
                      }
                    >
                      {ptTicket.ticketNumber} ↗
                    </div>
                  ) : stTicket?.ticketNumber ? (
                    <div
                      className="fw-semibold text-primary text-truncate cursor-pointer"
                      title="Click to view Salary Ticket"
                      style={{ fontSize: "13.5px", cursor: "pointer" }}
                      onClick={() =>
                        navigate(
                          `${RoutesLink.salary_ticket_detail}/${stTicket.id}`
                        )
                      }
                    >
                      {stTicket.ticketNumber} ↗
                    </div>
                  ) : (
                    <div
                      className="fw-semibold text-dark"
                      style={{ fontSize: "13.5px" }}
                    >
                      --
                    </div>
                  )}
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Source Requisition
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Site Name
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={siteName}
                    style={{ fontSize: "13.5px" }}
                  >
                    {siteName}
                  </div>
                  <div
                    className="text-secondary small mt-0.5 text-truncate"
                    style={{ fontSize: "11px" }}
                  >
                    Project / Operating Location
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Payment Method
                  </div>
                  <div
                    className="fw-semibold text-dark"
                    style={{ fontSize: "13.5px" }}
                  >
                    {transaction?.paymentMethod || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Disbursement Channel
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Transaction Date
                  </div>
                  <div
                    className="fw-semibold text-dark"
                    style={{ fontSize: "13.5px" }}
                  >
                    {paymentAdvisoryData?.transactionDate
                      ? moment(
                          paymentAdvisoryData.transactionDate
                        ).format("DD-MM-YYYY")
                      : "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Execution Timestamp
                  </div>
                </div>
              </div>

              {/* Conditional Reference / Bank fields */}
              {isCash && (
                <div className="col-12 col-sm-6 col-lg-3">
                  <div
                    className="p-3 rounded-2 h-100"
                    style={{
                      background: "#f8fafc",
                      border: "1px solid #f1f5f9",
                    }}
                  >
                    <div
                      className="text-muted text-uppercase mb-1"
                      style={{
                        fontSize: "11px",
                        fontWeight: 700,
                        letterSpacing: "0.05em",
                      }}
                    >
                      Reference Name
                    </div>
                    <div
                      className="fw-semibold text-dark text-truncate"
                      title={paymentAdvisoryData?.referenceName}
                      style={{ fontSize: "13.5px" }}
                    >
                      {paymentAdvisoryData?.referenceName || "--"}
                    </div>
                    <div
                      className="text-secondary small mt-0.5"
                      style={{ fontSize: "11px" }}
                    >
                      Cash Recipient / Handler
                    </div>
                  </div>
                </div>
              )}

              {!isCash && (
                <div className="col-12 col-sm-6 col-lg-3">
                  <div
                    className="p-3 rounded-2 h-100"
                    style={{
                      background: "#f8fafc",
                      border: "1px solid #f1f5f9",
                    }}
                  >
                    <div
                      className="text-muted text-uppercase mb-1"
                      style={{
                        fontSize: "11px",
                        fontWeight: 700,
                        letterSpacing: "0.05em",
                      }}
                    >
                      UTR Number
                    </div>
                    <div
                      className="fw-semibold text-dark text-truncate"
                      title={transaction?.utr}
                      style={{ fontSize: "13.5px" }}
                    >
                      {transaction?.utr || "--"}
                    </div>
                    <div
                      className="text-secondary small mt-0.5"
                      style={{ fontSize: "11px" }}
                    >
                      Banking Reference ID
                    </div>
                  </div>
                </div>
              )}

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Created By
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={transaction?.user?.name}
                    style={{ fontSize: "13.5px" }}
                  >
                    {transaction?.user?.name || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Advisory Author
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Banking Transfer Details Card (When Bank Transfer Method) */}
        {isBankTransfer && (
          <div
            className="card border-0 shadow-sm rounded-3 mb-4 overflow-hidden"
            style={{ background: "#ffffff" }}
          >
            <div
              className="card-header bg-white py-3 px-4 d-flex align-items-center justify-content-between border-bottom"
              style={{ borderColor: "#f1f5f9" }}
            >
              <div className="d-flex align-items-center gap-2">
                <div
                  className="rounded-2 p-1.5 d-flex align-items-center justify-content-center"
                  style={{ background: "#f1f5f9", color: "#475569" }}
                >
                  <BankIcon />
                </div>
                <h5
                  className="mb-0 fw-bold text-dark"
                  style={{ fontSize: "15px" }}
                >
                  Beneficiary Banking Credentials
                </h5>
              </div>
              <span
                className="badge bg-light text-secondary border px-3 py-1.5 rounded-pill"
                style={{ fontSize: "12px", fontWeight: 600 }}
              >
                {transaction?.paymentMethod || "Electronic Transfer"}
              </span>
            </div>

            <div className="card-body p-4">
              <div className="row g-3">
                <div className="col-12 col-sm-6 col-lg-3">
                  <div
                    className="p-3 rounded-2 h-100"
                    style={{
                      background: "#f8fafc",
                      border: "1px solid #e2e8f0",
                    }}
                  >
                    <div
                      className="text-muted text-uppercase mb-1"
                      style={{
                        fontSize: "11px",
                        fontWeight: 700,
                        letterSpacing: "0.04em",
                      }}
                    >
                      Bank Name
                    </div>
                    <div
                      className="fw-semibold text-dark text-truncate"
                      title={transaction?.bankName}
                      style={{ fontSize: "14px" }}
                    >
                      {transaction?.bankName || "--"}
                    </div>
                    <div
                      className="text-secondary small mt-0.5"
                      style={{ fontSize: "11px" }}
                    >
                      Financial Institution
                    </div>
                  </div>
                </div>

                <div className="col-12 col-sm-6 col-lg-3">
                  <div
                    className="p-3 rounded-2 h-100"
                    style={{
                      background: "#f8fafc",
                      border: "1px solid #e2e8f0",
                    }}
                  >
                    <div
                      className="text-muted text-uppercase mb-1"
                      style={{
                        fontSize: "11px",
                        fontWeight: 700,
                        letterSpacing: "0.04em",
                      }}
                    >
                      Account Holder Name
                    </div>
                    <div
                      className="fw-semibold text-dark text-truncate"
                      title={transaction?.accountHolderName}
                      style={{ fontSize: "14px" }}
                    >
                      {transaction?.accountHolderName || "--"}
                    </div>
                    <div
                      className="text-secondary small mt-0.5"
                      style={{ fontSize: "11px" }}
                    >
                      Primary Account Title
                    </div>
                  </div>
                </div>

                <div className="col-12 col-sm-6 col-lg-3">
                  <div
                    className="p-3 rounded-2 h-100"
                    style={{
                      background: "#f8fafc",
                      border: "1px solid #e2e8f0",
                    }}
                  >
                    <div
                      className="text-muted text-uppercase mb-1"
                      style={{
                        fontSize: "11px",
                        fontWeight: 700,
                        letterSpacing: "0.04em",
                      }}
                    >
                      Account Number
                    </div>
                    <div
                      className="fw-bold text-dark text-truncate"
                      title={transaction?.accountNumber}
                      style={{ fontSize: "14px", letterSpacing: "0.02em" }}
                    >
                      {transaction?.accountNumber || "--"}
                    </div>
                    <div
                      className="text-secondary small mt-0.5"
                      style={{ fontSize: "11px" }}
                    >
                      Destination Account
                    </div>
                  </div>
                </div>

                <div className="col-12 col-sm-6 col-lg-3">
                  <div
                    className="p-3 rounded-2 h-100"
                    style={{
                      background: "#f0fdf4",
                      border: "1px solid #bbf7d0",
                    }}
                  >
                    <div
                      className="text-uppercase mb-1"
                      style={{
                        fontSize: "11px",
                        fontWeight: 700,
                        letterSpacing: "0.04em",
                        color: "#166534",
                      }}
                    >
                      Settled Amount
                    </div>
                    <div
                      className="fw-bold text-success"
                      style={{ fontSize: "16px" }}
                    >
                      {formatAmount(transaction?.amount) || "--"}
                    </div>
                    <div
                      className="text-muted small mt-0.5"
                      style={{ fontSize: "11px" }}
                    >
                      Total Transferred
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Payment References & Remarks (2-Column Grid) */}
        <div className="row g-4 mb-4">
          {/* Documents Card */}
          <div className="col-12 col-lg-5">
            <div
              className="card border-0 shadow-sm rounded-3 h-100"
              style={{ background: "#ffffff" }}
            >
              <div
                className="card-header bg-white py-3 px-4 d-flex align-items-center justify-content-between border-bottom"
                style={{ borderColor: "#f1f5f9" }}
              >
                <div className="d-flex align-items-center gap-2">
                  <span style={{ fontSize: "16px" }}>📄</span>
                  <h5
                    className="mb-0 fw-bold"
                    style={{ fontSize: "14.5px", color: "#0f172a" }}
                  >
                    Payment References
                  </h5>
                </div>
                <span
                  className="badge bg-light text-secondary border px-2.5 py-1 rounded-pill"
                  style={{ fontSize: "11px", fontWeight: 600 }}
                >
                  {paymentAdvisoryData?.documents?.length || 0}
                </span>
              </div>

              <div className="card-body p-4">
                {paymentAdvisoryData?.documents?.length > 0 ? (
                  <div className="d-flex flex-column gap-2.5">
                    {paymentAdvisoryData?.documents?.map((doc, index) => (
                      <div
                        key={index}
                        onClick={() => handleDocumentClick(doc)}
                        className="p-3 rounded-2 d-flex align-items-center justify-content-between cursor-pointer"
                        style={{
                          background: "#f8fafc",
                          border: "1px solid #e2e8f0",
                          cursor: "pointer",
                          transition: "all 0.15s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = "#f1f5f9";
                          e.currentTarget.style.borderColor = "#cbd5e1";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = "#f8fafc";
                          e.currentTarget.style.borderColor = "#e2e8f0";
                        }}
                      >
                        <div className="d-flex align-items-center gap-2.5 text-truncate me-2">
                          <div
                            className="rounded-2 p-1.5 d-flex align-items-center justify-content-center flex-shrink-0"
                            style={{ background: "#eff6ff", color: "#2563eb" }}
                          >
                            <DocumentIcon />
                          </div>
                          <span
                            className="fw-semibold text-dark text-truncate"
                            style={{ fontSize: "13px" }}
                            title={doc?.name || "Document"}
                          >
                            {doc?.name || `Document #${index + 1}`}
                          </span>
                        </div>
                        <div
                          className="text-secondary small flex-shrink-0"
                          style={{ fontSize: "11px" }}
                        >
                          {doc?.updatedAt
                            ? moment(doc.updatedAt).format(
                                "DD MMM YYYY | h:mm a"
                              )
                            : "View"}
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div
                    className="p-4 rounded-2 text-center text-muted"
                    style={{ border: "2px dashed #e2e8f0" }}
                  >
                    <div style={{ fontSize: "24px", opacity: 0.5 }}>📁</div>
                    <div className="small mt-1 fw-medium">
                      No Payment References Found
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Remarks Card */}
          <div className="col-12 col-lg-7">
            <div
              className="card border-0 shadow-sm rounded-3 h-100"
              style={{ background: "#ffffff" }}
            >
              <div
                className="card-header bg-white py-3 px-4 d-flex align-items-center gap-2 border-bottom"
                style={{ borderColor: "#f1f5f9" }}
              >
                <span style={{ fontSize: "16px" }}>📝</span>
                <h5
                  className="mb-0 fw-bold"
                  style={{ fontSize: "14.5px", color: "#0f172a" }}
                >
                  Remarks
                </h5>
              </div>
              <div className="card-body p-4">
                <div
                  className="p-3 rounded-2"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    minHeight: "120px",
                    fontSize: "13.5px",
                    color: "#334155",
                    whiteSpace: "pre-wrap",
                  }}
                >
                  {paymentAdvisoryData?.remark || "No Remarks Provided..."}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ViewDocumentModal
        modal={modal}
        toggle={toggleModal}
        selectedDocument={selectedDocument}
      />
    </>
  );
}
